import React from 'react'

function ErrorComponent() {
  return (
    <>
        <div className='mx-auto w-10/12 bg-white rounded-lg p-4'>
            <p className='text-center'>An error Occured trying to track item</p>
        </div>
    </>
  )
}

export default ErrorComponent